// extracted by mini-css-extract-plugin
export var item = "list-item-module--item--3RC2f";